import React from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
  animation: spin 4s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    30% {
      transform: rotate(180deg);
    }
    50% {
      transform: rotate(180deg);
    }
    80% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const ClockIcon = () => {
  return (
    <IconWrapper>
      <svg width="44" height="58" viewBox="0 0 44 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.70797 47.6698L5.70797 55.2204H1.5327C1.16603 55.2204 0.814381 55.365 0.555103 55.6226C0.29583 55.8801 0.150166 56.2294 0.150166 56.5936C0.150166 56.9578 0.29583 57.3071 0.555103 57.5646C0.814381 57.8221 1.16603 57.9668 1.5327 57.9668L42.4842 57.9668C42.8508 57.9668 43.2025 57.8221 43.4618 57.5646C43.721 57.3071 43.8667 56.9578 43.8667 56.5936C43.8667 56.2294 43.721 55.8801 43.4618 55.6226C43.2025 55.365 42.8508 55.2204 42.4842 55.2204L38.9725 55.2204L38.9725 47.7824C38.9719 46.3652 38.671 44.9641 38.0895 43.6699C37.5079 42.3758 36.6587 41.2177 35.5971 40.2709L23.7035 29.4362L35.0956 18.5973C36.1081 17.6523 36.9155 16.5117 37.468 15.2456C38.0206 13.9794 38.3068 12.6144 38.3089 11.2344L38.3089 2.76324L42.4842 2.76324C42.8508 2.76324 43.2025 2.61856 43.4618 2.36103C43.721 2.1035 43.8667 1.75422 43.8667 1.39002C43.8667 1.02582 43.721 0.676533 43.4618 0.419003C43.2025 0.161472 42.8508 0.0167961 42.4842 0.0167961L1.53257 0.0167961C1.1659 0.0167961 0.814243 0.161472 0.554966 0.419003C0.295689 0.676533 0.150032 1.02582 0.150032 1.39002C0.150032 1.75422 0.295689 2.1035 0.554966 2.36103C0.814243 2.61856 1.1659 2.76324 1.53257 2.76324H5.04504L5.04504 11.1218C5.04569 12.539 5.34657 13.9402 5.92811 15.2343C6.50965 16.5284 7.35885 17.6865 8.42051 18.6333L20.3141 29.468L8.92196 40.3066C7.90927 41.2516 7.10178 42.3922 6.54908 43.6584C5.99638 44.9246 5.71015 46.2897 5.70797 47.6698ZM30.518 2.76324L22.0811 12.5087L13.6444 2.76324L30.518 2.76324ZM10.271 16.5927C9.49696 15.9036 8.87768 15.0603 8.45353 14.1177C8.02938 13.175 7.80987 12.1543 7.80929 11.1218L7.80929 2.76324H9.99729L21.0327 15.5103C21.1625 15.6602 21.3233 15.7805 21.5043 15.863C21.6852 15.9455 21.8819 15.9882 22.0809 15.9882C22.28 15.9882 22.4767 15.9455 22.6576 15.863C22.8385 15.7805 22.9994 15.6602 23.1292 15.5103L34.1647 2.76324H35.5438L35.5438 11.2344C35.5423 12.2399 35.3336 13.2345 34.9305 14.1569C34.5275 15.0793 33.9387 15.91 33.2003 16.5979C33.1963 16.6016 33.1921 16.6055 33.1883 16.6093L21.9875 27.2655L10.2831 16.6034C10.2797 16.6 10.2757 16.5963 10.271 16.5927ZM10.816 42.3063C10.82 42.3026 10.8242 42.2987 10.8281 42.2949L22.0288 31.6387L33.7333 42.3008L33.7465 42.3121C34.5206 43.0012 35.1399 43.8445 35.564 44.7871C35.9882 45.7297 36.2077 46.7505 36.2083 47.783L36.2083 55.2204L8.47374 55.2204L8.47374 47.6698C8.47511 46.6643 8.68367 45.6698 9.0866 44.7473C9.48952 43.8249 10.0783 42.9942 10.8166 42.3063H10.816Z"
          fill="url(#paint0_linear_8944_252273)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_8944_252273"
            x1="43.866"
            y1="28.995"
            x2="0.150035"
            y2="28.995"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4AA3F5" />
            <stop offset="1" stopColor="#2C6EF2" />
          </linearGradient>
        </defs>
      </svg>
    </IconWrapper>
  )
}

export default ClockIcon
